import React, { useContext, useRef, useState } from 'react';
import { UserContext } from '../../App';
import BackDropUI from '../MaterialUI/BackDropUI';
const axios = require('axios').default;

const Add_pro = () => {
    const [cardDisplay, setCardDisplay, authentication, setAuthentication, snackBarUI, setSnackBarUI, backdropUI, setBackdropUI] = useContext(UserContext);
    const centerForm = 'd-flex flex-column p-5 w-75 form-admin';
    const [img, setImg] = useState("");

    const titleRef = useRef(undefined);
    const summaryRef = useRef(undefined);
    const tag1Ref = useRef(undefined);
    const tag2Ref = useRef(undefined);
    const tag3Ref = useRef(undefined);
    const tag4Ref = useRef(undefined);
    const categoryRef = useRef(undefined);
    const liveLink = useRef(undefined);

    const projectSubmit = event => {
        event.preventDefault();

        const obj = {
            image: img,
            title: titleRef.current.value,
            summary: summaryRef.current.value,
            tag: [tag1Ref.current.value, tag2Ref.current.value, tag3Ref.current.value, tag4Ref.current.value],
            category: categoryRef.current.value,
            live: liveLink.current.value
        }

        setBackdropUI(true);
        fetch('https://stormy-mesa-29040.herokuapp.com/addProjects', {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify([obj])
        })
            .then(res => res.json())
            .then(data => {
                setBackdropUI(false)
                alert('Success')
            })
            .catch(err => {
                setBackdropUI(false)
                alert(err)
            })
    }

    const handleImage = event => {
        const imageData = new FormData();
        imageData.set('key', '2e6b03bfb364d782703bbc4ad0f67996');
        imageData.append('image', event.target.files[0])

        setBackdropUI(true);
        axios.post('https://api.imgbb.com/1/upload', imageData)
            .then(function (response) {
                setBackdropUI(false);
                setImg(response.data.data.display_url);
                alert('Image operation completed')
            })
            .catch(error => {
                setBackdropUI(false);
                alert(error)
            });
    }


    return (
        <div className="center-admin">
            <h1 className="text-center">Add Projects</h1>
            <form className={centerForm} onSubmit={projectSubmit}>
                <input ref={titleRef} type="text" placeholder="Title" required />
                <input ref={summaryRef} type="text" placeholder="Summary" required />
                <input ref={tag1Ref} type="text" placeholder="Tag1" required />
                <input ref={tag2Ref} type="text" placeholder="Tag2" />
                <input ref={tag3Ref} type="text" placeholder="Tag3" />
                <input ref={tag4Ref} type="text" placeholder="Tag4" />
                <input ref={liveLink} type="text" placeholder="Live link" required />
                <input ref={categoryRef} type="text" placeholder="Category (Example: ReactJS, Javascript, HTML/CSS)" />
                <input onChange={handleImage} type="file" required />
                <input className="btn btn-dark" type="submit" value="SUBMIT" />
            </form>
            <BackDropUI />
        </div>
    );
};

export default Add_pro;